﻿(() => {
  function afloraToggleFilter() {
    var sidebar = document.getElementById('aflora-filter-sidebar');
    var trigger = document.querySelector('.aflora-collection__filter-trigger');
    if (!sidebar || !trigger) return;
    var open = sidebar.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(open));
  }

  function afloraUpdateSort(value) {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', value);
    params.delete('page');
    window.location.search = params.toString();
  }

  function afloraUpdatePerPage(value) {
    var allowed = ['12', '24', '48'];
    if (allowed.indexOf(value) === -1) return;
    var params = new URLSearchParams(window.location.search);
    params.set('per_page', value);
    params.delete('page');
    window.location.search = params.toString();
  }

  function afloraUpdateCartBadge(count) {
    document.querySelectorAll('.aflora-navbar__icon-link--cart').forEach(function (icon) {
      var badge = icon.querySelector('.aflora-navbar__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'aflora-navbar__badge';
          icon.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });

    document.querySelectorAll('[data-cart-mobile-link]').forEach(function (link) {
      link.textContent = count > 0 ? 'Cart (' + count + ')' : 'Cart';
    });
  }

  function afloraQuickAdd(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function(result) {
      if (!result.ok) {
        window.alert(result.data.description || result.data.message || 'Could not add item to cart.');
        return;
      }
      // Just refresh the cart icon badge count — no drawer/popup.
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { afloraUpdateCartBadge(cart.item_count); });
    }).catch(function() {
      window.location.href = '/cart';
    });
  }

  // Server-side filter via Shopify URL params — works with pagination.
  //   data-filter-key="tag"    → filter.p.tag=value
  //   data-filter-key="kind"   → filter.p.tag=value  (bundle/single)
  //   data-filter-key="type"   → filter.p.product_type=value
  //   data-filter-key="vendor" → filter.p.vendor=value
  //   data-filter-key="meta"   → filter.p.m.[data-meta-key]=value  (category metafield)
  var _filterTimer = null;
  function afloraApplyFilter() {
    afloraSyncFilterPills();
    clearTimeout(_filterTimer);
    _filterTimer = setTimeout(function () { afloraApplyFilterNow(); }, 1000);
  }
  function afloraApplyFilterNow() {
    var form = document.getElementById('aflora-collection-filters-form');
    if (!form) return;

    var params = new URLSearchParams();

    var sortEl = document.querySelector('.aflora-collection__sort-select');
    if (sortEl && sortEl.value) params.set('sort_by', sortEl.value);

    var perPageEl = document.querySelector('.aflora-collection__perpage-select');
    if (perPageEl && perPageEl.value) params.set('per_page', perPageEl.value);

    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
      var key     = input.dataset.filterKey;
      var val     = input.dataset.filterValue;
      var metaKey = input.dataset.metaKey;
      if (key === 'tag') {
        params.append('filter.p.tag', val);
      } else if (key === 'type') {
        params.append('filter.p.product_type', val);
      } else if (key === 'vendor') {
        params.append('filter.p.vendor', val);
      } else if (key === 'meta' && metaKey) {
        params.append('filter.p.m.' + metaKey, val);
      }
    });

    var s = params.toString();
    window.location.href = window.location.pathname + (s ? '?' + s : '');
  }

  // Restore checkbox state from URL after reload
  function afloraInitFilterState() {
    var form = document.getElementById('aflora-collection-filters-form');
    if (!form) return;

    var params  = new URLSearchParams(window.location.search);
    var tags    = params.getAll('filter.p.tag').map(function (v) { return v; });
    var types   = params.getAll('filter.p.product_type').map(function (v) { return v.toLowerCase(); });
    var vendors = params.getAll('filter.p.vendor').map(function (v) { return v.toLowerCase(); });

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      var key     = input.dataset.filterKey;
      var val     = (input.dataset.filterValue || '').toLowerCase();
      var metaKey = input.dataset.metaKey;
      if (key === 'tag' && tags.indexOf(val) !== -1) {
        input.checked = true;
      } else if (key === 'type' && types.indexOf(val) !== -1) {
        input.checked = true;
      } else if (key === 'vendor' && vendors.indexOf(val) !== -1) {
        input.checked = true;
      } else if (key === 'meta' && metaKey) {
        var metaVals = params.getAll('filter.p.m.' + metaKey).map(function (v) { return v.toLowerCase(); });
        if (metaVals.indexOf(val) !== -1) input.checked = true;
      }
    });
  }

  function afloraSyncFilterPills() {
    var container = document.getElementById('aflora-active-filters');
    var badge     = document.getElementById('aflora-filter-count');
    var form      = document.getElementById('aflora-collection-filters-form');
    if (!container || !badge || !form) return;

    var active = Array.from(form.querySelectorAll('input[type="checkbox"]:checked'));
    badge.textContent = String(active.length);
    badge.classList.toggle('is-hidden', active.length === 0);

    if (active.length === 0) {
      container.classList.remove('is-visible');
      container.innerHTML = '';
      return;
    }

    container.classList.add('is-visible');
    container.innerHTML =
      '<span class="aflora-collection__active-label">Active:</span>' +
      active.map(function (input, i) {
        return (
          '<button type="button" class="aflora-collection__pill" data-index="' + i + '">' +
          input.dataset.label + ' <span>\u00d7</span></button>'
        );
      }).join('') +
      '<button type="button" class="aflora-collection__clear-all">Clear All</button>';

    container.querySelectorAll('.aflora-collection__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var input = active[parseInt(pill.dataset.index, 10)];
        if (input) { input.checked = false; afloraApplyFilterNow(); }
      });
    });

    var clearAll = container.querySelector('.aflora-collection__clear-all');
    if (clearAll) {
      clearAll.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
        afloraApplyFilterNow();
      });
    }

  }

  window.afloraToggleFilter    = afloraToggleFilter;
  window.afloraUpdateSort      = afloraUpdateSort;
  window.afloraUpdatePerPage   = afloraUpdatePerPage;
  window.afloraQuickAdd        = afloraQuickAdd;
  window.afloraApplyFilter     = afloraApplyFilter;
  window.afloraApplyFilterNow  = afloraApplyFilterNow;

  // ── Scroll Reveal ────────────────────────────────────────────────
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-visible');
      revealIO.unobserve(e.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  function revealEl(el, delay) {
    if (!el || el.classList.contains('aflora-reveal')) return;
    el.classList.add('aflora-reveal');
    if (delay > 0) el.dataset.delay = String(Math.min(delay, 4));
    revealIO.observe(el);
  }

  function initReveal() {
    // Hero heading + description
    revealEl(document.querySelector('.aflora-collection-hero__title'), 0);
    revealEl(document.querySelector('.aflora-collection-hero__desc'), 1);

    // Product cards — stagger 0-3 cycling by row position
    document.querySelectorAll('.aflora-product-card').forEach(function (card, i) {
      revealEl(card, i % 4);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    afloraInitFilterState();
    afloraSyncFilterPills();
    initReveal();
  });
  document.addEventListener('shopify:section:load', function () {
    afloraInitFilterState();
    afloraSyncFilterPills();
    initReveal();
  });
})();
